import AppContext from "PFApp/app_context";
import React, { useContext } from "react";

import PaginatedGanttChart from "../paginated_gantt_chart";
import RolesGantt from "./roles_gantt";
import css from "./roles_gantt_view.module.scss";
import RolesHeader from "./roles_header";

const RolesGanttView = () => {
  const {
    store: {
      pages: {
        workflowPage: {
          roles: { data, fetchData }
        }
      }
    }
  } = useContext(AppContext);
  return (
    <div>
      <RolesHeader className={css.header} />
      <PaginatedGanttChart data={data} fetch={fetchData} ganttComponent={RolesGantt} />
    </div>
  );
};

export default RolesGanttView;
